import { useTranslation } from 'react-i18next';

import type { LogSource } from '../types/log.types';

// Source discriminator. Color is an FE concern; the Korean label comes from the
// backend-served label catalog (`labels` ns), keyed by auditSource.<code>.
// Keyed by the backend's wire source CODE (uppercase). ADMIN actions come from the admin web;
// MEDICAL_WEB from the medical-staff dashboard (labelled 대시보드). Falls back to a neutral style for any unmapped code.
const STYLE: Record<string, React.CSSProperties> = {
  ADMIN: {
    color: '#4b5563',
    background: '#f3f4f6',
    borderColor: '#d1d5db',
  },
  MEDICAL_WEB: {
    color: '#1e40af',
    background: '#dbeafe',
    borderColor: '#93c5fd',
  },
};
const FALLBACK_STYLE: React.CSSProperties = {
  color: '#4b5563',
  background: '#f3f4f6',
  borderColor: '#d1d5db',
};

export function LogSystemBadge({ source }: { source: LogSource }) {
  const { t } = useTranslation('labels');
  const s = STYLE[source] ?? FALLBACK_STYLE;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 4,
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        border: '1px solid',
        color: s.color,
        background: s.background,
        borderColor: s.borderColor,
      }}
    >
      {/* Degrade to the code itself, never to the lookup path — a catalog that has not caught
          up with a new source must not put `auditSource.SOMETHING` in front of a Korean-only user. */}
      {t(`auditSource.${source}`, { defaultValue: source })}
    </span>
  );
}
